// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"594":"about","981":"form-view"}[chunkId] || chunkId) + "." + {"594":"b676a7cb","693":"a7927466","981":"67522e79"}[chunkId] + ".js";
};